import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import Divider from '@material-ui/core/Divider'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Typography from '@material-ui/core/Typography'
import { PGA_COACH_PRIVATE_CATEGORY_OPTIONS } from '@lib/pga-coach/constants'
import {
  ChevronDown,
  User,
  COACH_PROFILE_FILTER_ICON_PROPS,
} from '@lib/pga-coach/coach-profile-icons'

const ALL_PRIVATE_CATEGORY_IDS = PGA_COACH_PRIVATE_CATEGORY_OPTIONS.map((c) => c.id)

export default function PrivateFormatChip({
  classes,
  isPrivateSelected,
  privateCategories,
  onToggleAll,
  onCategoryChange,
}) {
  const [dropdownAnchor, setDropdownAnchor] = useState(null)
  const selectedCount = privateCategories.length
  const hasSpecificCategories = selectedCount > 0 && selectedCount < ALL_PRIVATE_CATEGORY_IDS.length
  const label = hasSpecificCategories ? `Private (${selectedCount})` : 'Private'

  const handleDropdownClick = (event) => {
    event.stopPropagation()
    setDropdownAnchor(event.currentTarget)
  }

  const handleCategoryToggle = (categoryId) => {
    const next = privateCategories.includes(categoryId)
      ? privateCategories.filter((c) => c !== categoryId)
      : [...privateCategories, categoryId]
    onCategoryChange(next)
  }

  return (
    <>
      <div
        className={[
          classes.privateChipRoot,
          isPrivateSelected && classes.privateChipRootSelected,
        ].filter(Boolean).join(' ')}
      >
        <Button
          type="button"
          variant="text"
          aria-pressed={isPrivateSelected}
          className={classes.privateChipToggleButton}
          onClick={onToggleAll}
          startIcon={(
            <User
              {...COACH_PROFILE_FILTER_ICON_PROPS}
              size={16}
            />
          )}
        >
          {label}
        </Button>
        <Button
          type="button"
          variant="text"
          aria-label="Choose private offering categories"
          aria-haspopup="true"
          aria-expanded={Boolean(dropdownAnchor)}
          className={classes.privateChipMenuTrigger}
          onClick={handleDropdownClick}
        >
          <ChevronDown
            {...COACH_PROFILE_FILTER_ICON_PROPS}
            size={16}
          />
        </Button>
      </div>

      <Menu
        anchorEl={dropdownAnchor}
        open={Boolean(dropdownAnchor)}
        onClose={() => setDropdownAnchor(null)}
        keepMounted
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        getContentAnchorEl={null}
        PaperProps={{
          className: [classes.filterMenuPaper, classes.privateCategoryMenuPaper].join(' '),
        }}
      >
        <Box px={2} pt={1} pb={0.5}>
          <Typography variant="caption" color="textSecondary">
            Private offering categories
          </Typography>
        </Box>
        {PGA_COACH_PRIVATE_CATEGORY_OPTIONS.map((category) => {
          const checked = privateCategories.includes(category.id)
          return (
            <MenuItem
              key={category.id}
              onClick={() => handleCategoryToggle(category.id)}
              className={classes.filterMenuItem}
              dense
            >
              <Checkbox
                checked={checked}
                size="small"
                color="default"
                className={classes.privateCategoryCheckbox}
              />
              <Typography component="span" variant="body2">{category.label}</Typography>
            </MenuItem>
          )
        })}
        <Divider component="li" />
        <MenuItem
          onClick={() => {
            onCategoryChange([])
            setDropdownAnchor(null)
          }}
          className={classes.filterMenuItem}
          dense
        >
          <span className={classes.privateCategoryAllSpacer} />
          <Typography component="span" variant="body2" color="textSecondary">
            All categories
          </Typography>
        </MenuItem>
      </Menu>
    </>
  )
}

PrivateFormatChip.propTypes = {
  classes: PropTypes.object.isRequired,
  isPrivateSelected: PropTypes.bool.isRequired,
  privateCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggleAll: PropTypes.func.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
}
